import React from 'react';
import { Link } from 'react-router-dom';
import styles from './Footer.module.css';
import { getCountry, localized } from '../../services/country';

export default function Footer() {
  const country=getCountry();
  return (
    <footer className={styles.footer}>
      <div className={`container ${styles.inner}`}>
        <div className={styles.brand}>
          <div className={styles.logo}>
            <svg width="24" height="24" viewBox="0 0 32 32" fill="none">
              <rect width="32" height="32" rx="8" fill="var(--primary)"/>
              <path d="M8 22L16 10L24 22H8Z" fill="white" fillOpacity="0.9"/>
              <circle cx="16" cy="10" r="3" fill="var(--accent)"/>
            </svg>
            <span>TalentosRD</span>
          </div>
          <p>{localized(`La plataforma de empleo en ${country.name}. Conectamos talento con oportunidades.`,`A plataforma de empregos no ${country.name}. Conectamos talentos a oportunidades.`)}</p>
          <a className={styles.email} href="mailto:info@talentosrd.com">info@talentosrd.com</a>
          <div className={styles.socials}>
            <a href="#" aria-label="Facebook">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M18 2h-3a5 5 0 00-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 011-1h3z"/></svg>
            </a>
            <a href="#" aria-label="Instagram">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="2" y="2" width="20" height="20" rx="5"/><path d="M16 11.37A4 4 0 1112.63 8 4 4 0 0116 11.37z"/><circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none"/></svg>
            </a>
            <a href="#" aria-label="LinkedIn">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M16 8a6 6 0 016 6v7h-4v-7a2 2 0 00-2-2 2 2 0 00-2 2v7h-4v-7a6 6 0 016-6zM2 9h4v12H2z"/><circle cx="4" cy="4" r="2"/></svg>
            </a>
          </div>
        </div>
        <div className={styles.cols}>
          <div className={styles.col}>
            <h4>{localized('Candidatos','Candidatos')}</h4>
            <Link to="/jobs">{localized('Buscar empleos','Buscar vagas')}</Link>
            <Link to="/register?role=candidate">{localized('Crear perfil','Criar perfil')}</Link>
            <Link to="/dashboard/candidate/saved">{localized('Empleos guardados','Vagas salvas')}</Link>
            <Link to="/dashboard/candidate/applications">{localized('Mis postulaciones','Minhas candidaturas')}</Link>
          </div>
          <div className={styles.col}>
            <h4>Empresas</h4>
            <Link to="/register?role=company">{localized('Registrar empresa','Cadastrar empresa')}</Link>
            <Link to="/jobs/new">{localized('Publicar empleo','Publicar vaga')}</Link>
            <Link to="/companies">{localized('Directorio','Diretório')}</Link>
            <Link to="/pricing">{localized('Planes y precios','Planos e preços')}</Link>
          </div>
          <div className={styles.col}>
            <h4>TalentosRD</h4>
            <Link to="/about">{localized('Quiénes somos','Quem somos')}</Link>
            <a href="mailto:info@talentosrd.com">{localized('Contacto','Contato')}</a>
            <Link to="/blog">Blog</Link>
            <Link to="/help">{localized('Centro de ayuda','Central de ajuda')}</Link>
          </div>
        </div>
      </div>
      <div className={styles.bottom}>
        <div className="container">
          <span>© {new Date().getFullYear()} TalentosRD. {localized('Todos los derechos reservados.','Todos os direitos reservados.')}</span>
          <div className={styles.legal}>
            <Link to="/privacy">{localized('Política de privacidad','Política de privacidade')}</Link>
            <Link to="/terms">{localized('Términos de uso','Termos de uso')}</Link>
            <Link to="/cookies">Cookies</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
